<template>
    <div
        v-if="$page.props.settings.translations.media[type] && $page.props.settings.media[type].length > 0"
        class="media-container"
        :class="{'media-container--inline': !inline}"
    >
        <div class="media container">
            <div
                class="media__inner"
                :class="{
                    'media__inner--no-inline': !inline,
                    'media__inner--background': !withoutBackground,
                }"
            >
                <div class="media__list">
                    <div class="media__list-title">
                        {{ $page.props.settings.translations.media[type].text }}
                    </div>

                    <img
                        v-for="(value, index) in $page.props.settings.media[type]"
                        :key="index"
                        :src="value.url"
                        :alt="value.alt"
                        class="media__list-item"
                        loading="lazy"
                        :width="value?.width > 1 ? value.width : null"
                        :height="value?.height > 1 ? value.height : null"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    inline: {
        type: Boolean,
        required: false,
        default: false,
    },
    type: {
        type: String,
        required: false,
        default: 'testimonials',
    },
    withoutBackground: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-header-media";
</style>
